/** The Drones tab's map-layer pills — one list shared by the topbar pills and
 *  the mobile Filters count (ENG-319), so they cannot drift apart. */
export const DRONE_TOGGLES = [
  { key: 'showLabels', label: 'Target Info' },
  { key: 'showProjections', label: 'Target Projection' },
  { key: 'showObstacles', label: 'Obstacles', divider: 'before' as const },
  { key: 'showOIVolume', label: 'OI Volume' },
  { key: 'showDroneProjection', label: 'Drone Projection' },
  { key: 'showNMAC', label: 'NMAC Ring', divider: 'before' as const },
  { key: 'showSWC', label: 'SWC Ring' },
  { key: 'showEval', label: 'Eval Ring' },
  { key: 'showGeofences', label: 'Geofences', divider: 'before' as const },
  { key: 'showDaaLines', label: 'DAA Lines' },
] as const;
